import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const XrayNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/x-rays");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/x-rays", "/x-rays/test-result", "/x-rays/xray-types"];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/x-ray");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{ ml: "5px", "& .MuiTabs-indicator": { display: "none" } }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/x-rays" ? theme.palette.primary.main : "white",
                color: value === "/x-rays" ? "white" : "black",
              }}
              label={t("x_ray.dashboard")}
              value="/x-rays"
              component={NavLink}
              to="/x-rays"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/x-rays/test-result"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/x-rays/test-result" ? "white" : "black",
              }}
              label={t("x_ray.testResult")}
              value="/x-rays/test-result"
              component={NavLink}
              to="/x-rays/test-result"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/x-rays/xray-types"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/x-rays/xray-types" ? "white" : "black",
              }}
              label={t("x_ray.xrayType")}
              value="/x-rays/xray-types"
              component={NavLink}
              to="/x-rays/xray-types"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default XrayNav;
